import { EventEmitter, Injectable } from '@angular/core';
import { GkKendoUploadComponent } from './gk-kendo-upload.component';
import { GkKendoWindowService } from '../services/kendo-window/gk-kendo-window/gk-kendo-window.service';
import { KendoWindowInstanceNames } from '../services/kendo-window/kendo-window.model';
import {
  GkKendoUploadEvent,
  UploadConfig,
  UploadDocTypeName,
} from './gk-kendo-upload.model';
import { GkKendoUploadDocTypeDictionaryService } from './gk-kendo-upload-doc-type-dictionary/gk-kendo-upload-doc-type-dictionary.service';
import { UploadDocType } from './gk-kendo-upload-doc-type-dictionary/gk-kendo-upload-doc-type-dictionary.model';

@Injectable()
export class GkKendoUploadService {
  onUploadButtonClick: (
    e: EventEmitter<GkKendoUploadEvent>,
  ) => Promise<void> | undefined;
  constructor(
    private gkKendoWindowService: GkKendoWindowService,
    private gkKendoUploadDocTypeDictionaryService: GkKendoUploadDocTypeDictionaryService,
  ) {}

  openUploadWindow(uploadConfig: UploadConfig): void {
    const windowRef = this.gkKendoWindowService.open({
      parent: this,
      parentWindowInstanceName: uploadConfig.parentWindowInstanceName,
      windowInstanceName: KendoWindowInstanceNames.GkKendoUpload,
      title: `UPLOAD_WINDOW.SPECIFY_FILE_ATTR_TITLE`,
      content: GkKendoUploadComponent,
      width: 400,
    });

    const uploadComponent = windowRef.content
      .instance as GkKendoUploadComponent;

    uploadComponent.uploadSaveUrl = uploadConfig.uploadSaveUrl;
    uploadComponent.uploadData = uploadConfig.uploadData;
    uploadComponent.onUploadSuccess = uploadConfig.onUploadSuccess;
    uploadComponent.onUploadError = uploadConfig.onUploadError;

    if (uploadConfig.onUploadButtonClick) {
      this.onUploadButtonClick = uploadConfig.onUploadButtonClick;
    } else {
      this.onUploadButtonClick = undefined;
    }

    switch (uploadConfig.uploadDocTypeDict) {
      case UploadDocTypeName.WorkReports:
        this.gkKendoUploadDocTypeDictionaryService
          .getDocTypes(UploadDocTypeName.WorkReports)
          .subscribe((data) => {
            uploadComponent.typeOfDocs = data;
          });
        break;
      case UploadDocTypeName.Work:
        this.gkKendoUploadDocTypeDictionaryService
          .getDocTypes(UploadDocTypeName.Work)
          .subscribe((data) => {
            uploadComponent.typeOfDocs = data;
          });
        break;
      case UploadDocTypeName.FeeConfirmation:
        this.gkKendoUploadDocTypeDictionaryService
          .getDocTypes(UploadDocTypeName.FeeConfirmation)
          .subscribe((data) => {
            uploadComponent.typeOfDocs = data;
          });
        break;
      case UploadDocTypeName.CoordinationMeetingPortalCase:
        this.gkKendoUploadDocTypeDictionaryService
          .getDocTypes(UploadDocTypeName.CoordinationMeetingPortalCase)
          .subscribe((data) => {
            uploadComponent.typeOfDocs = data;
          });
        break;
      case UploadDocTypeName.EodKdokrodz:
        this.gkKendoUploadDocTypeDictionaryService
          .getDocTypes(UploadDocTypeName.EodKdokrodz)
          .subscribe((data) => {
            uploadComponent.typeOfDocs = data;
          });
        break;
      case UploadDocTypeName.Other:
        uploadComponent.typeOfDocs = [
          { id: 8, name: 'inny' },
        ] as UploadDocType[];

        break;
      default:
        this.gkKendoUploadDocTypeDictionaryService
          .getDocTypes(UploadDocTypeName.Default)
          .subscribe((data) => {
            uploadComponent.typeOfDocs = data;
          });
        break;
    }
  }
}
